// Created by carsonaberle at 4/6/21
import React from 'react';
import './styles';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/react-hoc';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { commonMapDispatchToProps, commonMapStateToProps, getExternalBaseUrl } from '../../../utils/Helpers/AppHelper';
import UIIconButton from '../../UI/UIIconButton';
import { STATUS_LIVE } from '../../../utils/Config/Constants';
import { CopyIcon, ShareWhite } from '../../../assets/icons';
import UIOverlayCard from '../../UI/UIOverlayCard';
import { UI_ICON_BUTTON_OUTLINE_TYPE } from '../../UI/UIIconButton/config';

function ShareListingModal({ listing, hideModal, service, showSuccessMessage }) {
	const virtualTourPath = `/virtualtour/${listing.id}`;
	const externalPath = `/external/${listing.id}`;
	return (
		<UIOverlayCard
			hideModal={hideModal}
			title={'Sharing options'}
			description={'Share the management link to your team, and the virtual tour link to everyone else'}>
			<div className='shareModal'>
				<CopyToClipboard text={getExternalBaseUrl() + externalPath} onCopy={() => showSuccessMessage('Successfully copied external link to clipboard!')}>
					<UIIconButton
						className='shareModal__button'
						isDisabled={service && service.status !== STATUS_LIVE}
						disabledErrorMessage={'This service is in progress! Check back once your content is completed for a link to give your clients.'}
						icon={ShareWhite}
						text='external management link'
						onClick={(e) => e.stopPropagation()}
					/>
				</CopyToClipboard>
				<CopyToClipboard onCopy={() => showSuccessMessage('Copied virtual tour link to your clipboard!')} text={getExternalBaseUrl() + virtualTourPath}>
					<UIIconButton
						type={UI_ICON_BUTTON_OUTLINE_TYPE}
						icon={CopyIcon}
						text={'virtual tour link'}
						className='virtualTourCard__links--copy'
						onClick={(e) => e.stopPropagation()}
					/>
				</CopyToClipboard>
			</div>
		</UIOverlayCard>
	);
}

ShareListingModal.propTypes = {
	listing: PropTypes.object.isRequired,
	hideModal: PropTypes.func.isRequired
};

export default withApollo(connect(commonMapStateToProps, commonMapDispatchToProps)(ShareListingModal));
